export function ChunkArray(array: Array<any>, size: number): Array<any> {
	return new Array(Math.ceil(array.length / size)).fill(1).map(() => array.splice(0, size));
}
